import { InvitedUser } from '@appTypes/esb/advancements/events/event';

export default ({
  invitedUsers = [],
  userId = 0,
  canRsvp = false,
}: {
  invitedUsers?: InvitedUser[];
  userId?: number;
  canRsvp?: boolean;
}) =>
  canRsvp &&
  invitedUsers.includes(
    invitedUsers.find(invitee => invitee.userId === userId) ??
      ({} as InvitedUser),
  );
